import React, { useState, useEffect } from 'react';
import './OfflineStatus.css';

const OfflineStatus: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOfflineMessage, setShowOfflineMessage] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOfflineMessage(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOfflineMessage(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Show offline message if already offline
    if (!navigator.onLine) {
      setShowOfflineMessage(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Auto-hide the offline message after 5 seconds when back online
  useEffect(() => {
    if (isOnline && showOfflineMessage) {
      const timer = setTimeout(() => {
        setShowOfflineMessage(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isOnline, showOfflineMessage]);

  if (!showOfflineMessage && isOnline) {
    return null;
  }

  return (
    <div className={`offline-status ${isOnline ? 'online' : 'offline'}`}>
      <div className="offline-content">
        {isOnline ? (
          <>
            <span className="status-icon">🟢</span>
            <span className="status-text">Back online! Syncing data...</span>
          </>
        ) : (
          <>
            <span className="status-icon">🔴</span>
            <span className="status-text">
              You're offline. Some features may be limited, but cached content is available.
            </span>
          </>
        )}
        
        <button
          onClick={() => setShowOfflineMessage(false)}
          className="close-button"
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default OfflineStatus;